import React from "react";
import { connect } from "react-redux";
import { Notify } from "react-redux-notify";
import { hideUserOTPModal } from "../../store/actions/ModalAction";

import Footer from "./Footer/Footer";
import OTPModal from "../Modals/OTPModal";
import AuthHeader from "./Header/AuthHeader";

const AuthLayout = (props) => {
  const handleCloseOTPModal = () => {
    props.dispatch(hideUserOTPModal());
  };

  return (
    <>
      <Notify position="TopRight" />
      <AuthHeader />
      <div className="landing-main-wrapper dj">
        {React.cloneElement(props.children)}
      </div>
      <Footer />
      <OTPModal
        handleClose={handleCloseOTPModal}
        show={props.modals.userOTPModal.show}
        data={props.modals.userOTPModal}
        payload={props.modals.userOTPModal}
      />
    </>
  );
};

const mapStateToPros = (state) => ({
  modals: state.modals,
  profile: state.users.profile,
});

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(mapStateToPros, mapDispatchToProps)(AuthLayout);
